/**
 * The publish-time contract for a desktop status message, shared by the admin panel that types one
 * and the API that accepts it. Both enforce every rule here: the panel so an operator sees the
 * problem while drafting, the server so a direct call can't bypass it. Kept in one place because a
 * limit raised on only one side refuses the write with no error anywhere the operator can see —
 * during the incident the status exists for.
 */

/**
 * The shell discards any response body over 64KB, so an over-long entry would publish a status no
 * build ever receives, with nothing to say so.
 */
export const MaxMessageEntryLength = 1000

export const MaxUrlLength = 2048

export const MaxOperatorNoteLength = 1000

/**
 * Matches the shell's own check (`isHttpsUrl` in `Backend/desktop/src/StatusPayload.ts`), which
 * parses rather than prefix-matches. A prefix check accepts `https://` and `https:// host`, which
 * the shell's parser then rejects — discarding the whole payload, so every build shows nothing
 * while the panel and both previews still render a working dialog.
 */
export function isHttpsUrl(value: string): boolean {
  try {
    return new URL(value).protocol === 'https:'
  } catch {
    return false
  }
}
